var _style, _defs, _mask, _g, _defs2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;filter:url(#Adobe_OpacityMaskFilter);}\n\t.st1{mask:url(#mask0_768_1596_00000153695393871286289990000009587312287868146357_);}\n\t.st2{fill:#FFFFFF;}\n\t.st3{clip-path:url(#SVGID_00000161633858957043497690000011628612737190378161_);}\n\t.st4{fill:#FF86FF;}\n\t.st5{fill:#E200F1;}\n\t.st6{fill:#FF59FF;}\n\t.st7{fill:#F41AFA;}\n\t.st8{fill:#BC00DE;}\n\t.st9{fill:#9900CC;}\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: -0.4,
    y: 0,
    width: 30.4,
    height: 29.8
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -0.4,
    y: 0,
    width: 30.4,
    height: 29.8,
    id: "mask0_768_1596_00000153695393871286289990000009587312287868146357_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30,0H0v30h30V0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.4,
    y: 0,
    className: "st2",
    width: 30.4,
    height: 29.8
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 30,
    height: 30
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096760210609691170410000007317984451683689893_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000096760210609691170410000007317984451683689893_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M12.8,14.1l-11-11v11H12.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1.5,0.3l14.1,14.1c0.2,0.2,0.3,0.4,0.3,0.6c0,0.2-0.1,0.5-0.3,0.6c-0.1,0.1-0.2,0.2-0.3,0.2 c-0.1,0-0.2,0.1-0.4,0.1H0.9c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.2-0.2-0.3C0,15.2,0,15.1,0,15V0.9 c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.2-0.3,0.4-0.3C0.7,0,0.9,0,1.1,0C1.3,0.1,1.4,0.1,1.5,0.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M17.2,15.9l11,11v-11H17.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M28.5,29.7L14.4,15.6c-0.2-0.2-0.3-0.4-0.3-0.6c0-0.2,0.1-0.5,0.3-0.6c0.1-0.1,0.2-0.2,0.3-0.2 c0.1,0,0.2-0.1,0.4-0.1h14.1c0.2,0,0.5,0.1,0.6,0.3c0.2,0.2,0.3,0.4,0.3,0.6v14.1c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.3 c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.4-0.1C28.7,29.9,28.6,29.8,28.5,29.7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M15.6,15.6L1.5,29.7c-0.1,0.1-0.2,0.2-0.3,0.2C1.1,30,1,30,0.9,30c-0.1,0-0.2,0-0.3-0.1s-0.2-0.1-0.3-0.2 c-0.1-0.1-0.2-0.2-0.2-0.3C0,29.3,0,29.2,0,29.1V15c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.1,0.3-0.2 c0.1,0,0.2-0.1,0.3-0.1H15c0.2,0,0.4,0,0.5,0.1c0.2,0.1,0.3,0.2,0.3,0.4c0.1,0.2,0.1,0.3,0.1,0.5C15.9,15.3,15.8,15.5,15.6,15.6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1.8,26.9l11-11h-11V26.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M0.3,28.5l14.1-14.1c0.1-0.1,0.2-0.2,0.3-0.2c0.1,0,0.2-0.1,0.4-0.1c0.2,0,0.5,0.1,0.6,0.3 c0.2,0.2,0.3,0.4,0.3,0.6v14.1c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2C15.3,30,15.1,30,15,30H0.9 c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.2-0.2-0.3C0,29.3,0,29.2,0,29.1c0-0.1,0-0.2,0.1-0.3 C0.1,28.6,0.2,28.5,0.3,28.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M14.1,17.2l-11,11h11V17.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M14.4,14.4L28.5,0.3c0.1-0.1,0.2-0.2,0.3-0.2C28.9,0,29,0,29.1,0c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.3,0.2 s0.1,0.2,0.2,0.3S30,0.8,30,0.9V15c0,0.1,0,0.2-0.1,0.3s-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2s-0.2,0.1-0.3,0.1H15 c-0.2,0-0.4,0-0.5-0.1c-0.2-0.1-0.3-0.2-0.3-0.4c-0.1-0.2-0.1-0.3-0.1-0.5C14.1,14.7,14.2,14.5,14.4,14.4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M28.2,3.1l-11,11h11V3.1z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M29.7,1.5L15.6,15.6c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0-0.2,0.1-0.4,0.1c-0.1,0-0.2,0-0.3-0.1 c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.3V0.9c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.2-0.3 c0.1-0.1,0.2-0.1,0.3-0.2C14.7,0,14.9,0,15,0h14.1c0.1,0,0.2,0,0.4,0.1c0.1,0,0.2,0.1,0.3,0.2C29.9,0.4,30,0.7,30,0.9 C30,1.1,29.9,1.4,29.7,1.5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M15.9,12.8l11-11h-11V12.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeon);
export default __webpack_public_path__ + "static/media/neon.c3f3c0c2eeecc7d724bfcce581d1b4bf.svg";
export { ForwardRef as ReactComponent };